var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_166)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4545 0H1.54547C1.13558 0 0.742489 0.162826 0.452657 0.452657C0.162826 0.742489 0 1.13558 0 1.54547L0 26.4545C0 26.8644 0.162826 27.2575 0.452657 27.5473C0.742489 27.8372 1.13558 28 1.54547 28H14.957V17.1719H11.3203V12.9336H14.957V9.81641C14.957 6.19992 17.1659 4.23063 20.393 4.23063C21.9379 4.23063 23.2663 4.34547 23.6523 4.39469V8.17414H21.4266C19.6711 8.17414 19.3309 9.00813 19.3309 10.2326V12.9336H23.5277L22.9808 17.1719H19.3309V28H26.4534C26.6565 28.0001 26.8576 27.9603 27.0452 27.8827C27.2328 27.8051 27.4033 27.6913 27.547 27.5477C27.6906 27.4042 27.8045 27.2338 27.8823 27.0462C27.96 26.8586 28 26.6576 28 26.4545V1.54547C28 1.13558 27.8372 0.742489 27.5473 0.452657C27.2575 0.162826 26.8644 0 26.4545 0Z",
    fill: "#4267B2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.332 28V17.1719H22.9824L23.5293 12.9336H19.332V10.2342C19.332 9.00979 19.6711 8.17581 21.4277 8.17581H23.6523V4.39526C23.2652 4.34386 21.9368 4.2312 20.393 4.2312C17.1664 4.2312 14.957 6.19995 14.957 9.81698V12.9342H11.3203V17.1719H14.957V28H19.332Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29_166",
    x: -14,
    y: -8,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29_166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29_166",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.39b5f28091c8d79f69a33a23b78beac4.svg";
export { ForwardRef as ReactComponent };